import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { NewsRouter } from '../../../news/types';
import { modules } from '../../modules';

@injectable()
export class NewsRouterService implements NewsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string) {
    this.history.push(`/${this.role.get()}/${modules.news.basename}/${id}`);
  }

  goToEdit(query: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.news.basename}/edit`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.news.basename}/edit`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.news.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.news.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreate(accountId: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.news.basename}/create`,
      search: `?account_id=${accountId}`,
    });
  }
}
